import styled from 'styled-components';
import {
    GROUP_BOX_PADDING_LEFT_RIGHT,
    GROUP_BOX_PADDING_TOP_BOTTOM,
} from '@atlassian/help-center-common-component/group-box';

export const MessageContainer = styled.div`
    /* Makes sure the raise request link has the same look as group box */
    padding: ${GROUP_BOX_PADDING_TOP_BOTTOM} ${GROUP_BOX_PADDING_LEFT_RIGHT};
`;
